import billingUIStore from './billingUIStore.js';
import billingDataStore from './billingDataStore.js';

export default {
  modules: {
    ui: billingUIStore,
    data: billingDataStore,
  },
};
